module.exports = __webpack_public_path__ + "img/menuIcon11.893a36be.png";